import React from 'react';
import PropTypes from 'prop-types';

import { INBOX_COUNT_MAX } from 'models/inbox_count';
import track from 'scripts/presentation/components/lib/track';

export default function BackButton({ count, isVisible, onNavigateBack, previousPath, showInboxCount }) {
  if (!isVisible) {
    return null;
  }

  count = count > INBOX_COUNT_MAX ? '999+' : count;

  let inboxBadgeCount = null;
  if (showInboxCount && count > 0) {
    inboxBadgeCount = <div className="navigation-inboxBadge">{count}</div>;
  }

  let handleOnClick = previousPath === 'My Inbox' ? track.click('breadcrumb-myInbox', onNavigateBack) : onNavigateBack;

  return (
    <div className="navigation-back">
      <div className="navigation-backLink" href="#" onClick={handleOnClick}>
        <span className="navigation-backIcon" />
        <span>{previousPath}</span>
        {inboxBadgeCount}
      </div>
    </div>
  );
}

BackButton.propTypes = {
  count: PropTypes.number,
  isVisible: PropTypes.bool,
  onNavigateBack: PropTypes.func.isRequired,
  previousPath: PropTypes.string.isRequired,
  showInboxCount: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/back_button.jsx